import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  let staticDefaultImage;
  staticDefaultImage = 'https://via.placeholder.com/80x80';

  const {
    margin,
    image,
    image2,
    numberCard,
    numberCard2,
    numberCard3,
    textCard,
    textCard2,
    textCard3,
  } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`GridImageText ${margin} `}>
        <div className="GridImageText__wrapper">
          <figure className="GridImageText__image">
            <img src={image.src || staticDefaultImage} alt={image.alt} />
          </figure>
        </div>
        <div className="GridImageText__wrapper">
          <div className="GridImageText__item">
            <RichText
              className="GridImageText__item--number"
              tagName="p"
              value={numberCard}
              placeholder="Número aqui"
              keepPlaceholderOnFocus
              onChange={(numberCard) => setAttributes({ numberCard })}
            />
            <RichText
              className="GridImageText__item--text"
              tagName="p"
              value={textCard}
              placeholder="Texto aqui"
              keepPlaceholderOnFocus
              onChange={(textCard) => setAttributes({ textCard })}
            />
          </div>
          <figure className="GridImageText__image">
            <img src={image2.src || staticDefaultImage} alt={image2.alt} />
          </figure>
        </div>
        <div className="GridImageText__wrapper">
          <div className="GridImageText__item">
            <RichText
              className="GridImageText__item--number"
              tagName="p"
              value={numberCard2}
              placeholder="Número aqui"
              keepPlaceholderOnFocus
              onChange={(numberCard2) => setAttributes({ numberCard2 })}
            />
            <RichText
              className="GridImageText__item--text"
              tagName="p"
              value={textCard2}
              placeholder="Texto aqui"
              keepPlaceholderOnFocus
              onChange={(textCard2) => setAttributes({ textCard2 })}
            />
          </div>
          <div className="GridImageText__item">
            <RichText
              className="GridImageText__item--number"
              tagName="p"
              value={numberCard3}
              placeholder="Número aqui"
              keepPlaceholderOnFocus
              onChange={(numberCard3) => setAttributes({ numberCard3 })}
            />
            <RichText
              className="GridImageText__item--text"
              tagName="p"
              value={textCard3}
              placeholder="Texto aqui"
              keepPlaceholderOnFocus
              onChange={(textCard3) => setAttributes({ textCard3 })}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
